export default __webpack_public_path__ + "static/media/GF_Main-Poster_Horizontal.d080f630.jpg";